import { getAPIUrl } from '../helpers/App';

export const APIgetImporter = serviceId => (
  window.axios.get(getAPIUrl(`/importers/${serviceId}`))
    .then(response => (response.data))
);

export const APIgetImports = serviceId => (
  window.axios.get(getAPIUrl(`/importers/${serviceId}/imports`))
    .then(response => (response.data))
);

export const APIcreateImport = (serviceId, params) => (
  window.axios.post(getAPIUrl(`/importers/${serviceId}/imports`), params)
    .then(response => (response.data))
);

export const APIhideImport = importUuid => (
  window.axios.post(getAPIUrl(`/imports/${importUuid}/hide`))
    .then(response => (response.data))
);

export const APIretryImport = importUuid => (
  window.axios.post(getAPIUrl(`/imports/${importUuid}/retry`))
    .then(response => (response.data))
);

export const APIimporterLoadFiles = (serviceId, params) => (
  window.axios.get(getAPIUrl(`/importers/${serviceId}/files`), { params })
    .then(response => (response.data))
);

export const APIgetFTPAccounts = params => (
  window.axios.get(getAPIUrl('/importers/ftp/accounts'), { params })
    .then(response => (response))
);

export const APIcreateFTPAccount = account => (
  window.axios.post(getAPIUrl('/importers/ftp/accounts'), { account })
    .then(response => (response))
);

export const APIupdateFTPAccount = (accountId, account) => (
  window.axios.patch(getAPIUrl(`/importers/ftp/accounts/${accountId}`), { account })
    .then(response => (response))
);

export const APIdeleteFTPAccount = accountId => (
  window.axios.delete(getAPIUrl(`/importers/ftp/accounts/${accountId}`))
    .then(response => (response))
);

export const APIgetFTPImportFiles = params => (
  window.axios.get(getAPIUrl('/importers/ftp/queue'), { params })
    .then(response => (response))
);
